import React from 'react';
import { User } from '@alien-platform/bo-sdk-v2';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import dayjs from 'dayjs';

import { Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';
import { StatusChip } from '@/components/core/status-chip';

export function StaffDetailsTable({ userData }: { userData: User }): React.JSX.Element {
  const tableData: Row[] = [
    {
      label: {
        text: 'Nickname',
      },
      value: {
        text: userData.nickname,
      },
    },
    {
      label: {
        text: 'Email',
      },
      value: {
        text: userData.email,
      },
    },

    {
      label: {
        text: 'Role',
      },
      value: {
        component: <StatusChip status={userData.role} />,
      },
    },
    {
      label: {
        text: 'Created At',
      },
      value: {
        component: (
          <Stack sx={{ width: 1, alignItems: 'end' }}>
            <Typography sx={{ textWrap: 'nowrap' }} variant="body2">
              {dayjs(userData.createdAt).format('MMM D, YYYY h:mm A')}
            </Typography>
            <Typography sx={{ textWrap: 'nowrap' }} variant="caption" color="textSecondary">
              {dayjs(userData.createdAt).fromNow()}
            </Typography>
          </Stack>
        ),
      },
    },
  ];

  return <HorizontalTable tableData={tableData} />;
}
